export default {
  "mainVegetable": "laxanika",
  "mainVegetable/01": "laxanika/melitzanes",
  "mainVegetable/02": "laxanika/sparaggia",
  "mainVegetable/03": "laxanika/abokanto",
  "mainVegetable/04": "laxanika/pantzaria",
  "mainVegetable/05": "laxanika/mprokolo",
  "mainVegetable/06": "laxanika/karota",
  "mainVegetable/07": "laxanika/selino",
  "mainVegetable/08": "laxanika/manitaria",
  "mainVegetable/09": "laxanika/laxano",
  "mainVegetable/10": "laxanika/laxanakia-bryjellon",
  "mainVegetable/11": "laxanika/laxano-kinas",
  "mainVegetable/12": "laxanika/koynoypidi",
  "mainVegetable/13": "laxanika/laxanosalata",
  "mainVegetable/14": "laxanika/aggoyri",
  "mainVegetable/15": "laxanika/kolokythakia",
  "mainVegetable/16": "laxanika/antidi",
  "mainVegetable/17": "laxanika/spanaki",
  "mainVegetable/18": "laxanika/fasolia",
  "mainVegetable/19": "laxanika/fasolia",
  "mainVegetable/20": "laxanika/plake-fasolia",
  "mainVegetable/21": "laxanika/apojhramena-fasolia",
  "mainVegetable/22": "laxanika/prasina-fasolia",
  "mainVegetable/23": "laxanika/fakes",
  "mainVegetable/24": "laxanika/makedoinh",
  "mainVegetable/25": "laxanika/perissotero",
  "mainVegetable/26": "laxanika/salata-mesklan-",
  "mainVegetable/27": "laxanika/goggylia",
  "mainVegetable/28": "laxanika/kremmydia",
  "mainVegetable/29": "laxanika/mpizelia",
  "mainVegetable/30": "laxanika/piperies",
  "mainVegetable/31": "laxanika/patates-kai-patates",
  "mainVegetable/32": "laxanika/fytra-sogias",
  "mainVegetable/33": "laxanika/rapanaki",
  "mainVegetable/34": "laxanika/salata-me-fylla-belanidias",
  "mainVegetable/35": "laxanika/frisee-salata",
  "mainVegetable/36": "laxanika/salata-me-aismpergk",
  "mainVegetable/37": "laxanika/piemontezikh-salata",
  "mainVegetable/38": "laxanika/salata-ryzioy",
  "mainVegetable/39": "laxanika/romaike-salata",
  "mainVegetable/40": "laxanika/neara-fyta-",
  "mainVegetable/41": "laxanika/maroyli",
  "mainVegetable/42": "laxanika/arnia-maroylia",
  "mainVegetable/43": "laxanika/roka",
  "mainVegetable/44": "laxanika/lagoxorto-",
  "mainVegetable/45": "laxanika/tampoyle",
  "mainVegetable/46": "laxanika/tomates",
  "mainVegetable/47": "laxanika/fasolia-boytyroy-",
  "mainVegetable/48": "laxanika/rebythia",
  "mainVegetable/49": "laxanika/prasa",
  "mainVegetable/50": "laxanika/kolokytha",
  "mainVegetable/51": "laxanika/kokkino-fasoli",
  "mainVegetable/52": "laxanika/mela",
  "mainVegetable/53": "laxanika/kastana",
  "mainVegetable/54": "laxanika/damaskhna",
  "mainVegetable/55": "laxanika/kallierghtes",
  "mainVegetable/56": "laxanika/mayres-elies",
  "mainVegetable/57": "laxanika/agginares",
  "mainVegetable/58": "laxanika/kokkines-piperies",
  "mainVegetable/59": "laxanika/prasina-fasolia",
  "mainVegetable/60": "laxanika/anoijh",
  "mainVegetable/61": "laxanika/ratatoyi",
  "mainVegetable/62": "laxanika/koyskoys",
  "mainVegetable/63": "laxanika/tagine",
  "mainVegetable/64": "laxanika/sgoyra-laxanika",
  "mainVegetable/65": "laxanika/faba",
  "mainVegetable/66": "laxanika",
  "mainVegetable/67": "laxanika/koralli-fakes-",
  "mainVegetable/68": "laxanika/kinoa",
  "mainVegetable/69": "laxanika/eidos-sitoy",
  "mainVegetable/70": "laxanika/plhgoyri",
  "mainVegetable/71": "laxanika/kokkino-laxano",
  "mainVegetable/72": "laxanika/laxano",
  "mainVegetable/73": "laxanika/anthriskos-",
  "mainVegetable/74": "laxanika/sporoi-dhmhtriakon",
  "mainVegetable/75": "laxanika/ospria",
  "mainVegetable/76": "laxanika/glykopatata",
  "mainVegetable/77": "laxanika/kolokytha",
  "mainVegetable/78": "laxanika/lapatho-",
  "mainVegetable/79": "laxanika/fasolia",
  "mainVegetable/80": "laxanika/mikra-karota",
  "mainVegetable/81": "laxanika/arakas",
  "mainVegetable/82": "laxanika/entamame",
  "mainVegetable/83": "laxanika/krithari",
  "mainVegetable/84": "laxanika/anameikth-salata",
  "mainVegetable/85": "laxanika/radiki",
  "mainVegetable/86": "laxanika/arni-maroyli",
  "mainVegetable/87": "laxanika/spanaki-baby",
  "mainVegetable/88": "laxanika/maroyli",
  "mainVegetable/89": "laxanika/seskoylo",
  "mainVegetable/90": "laxanika/pastinakh",
  "mainVegetable/91": "laxanika/ryzi-black-venus",
  "mainVegetable/92": "laxanika/anameikta-fasolia",
  "mainVegetable/93": "laxanika/mayra-fasolia",
  "mainVegetable/94": "laxanika/mytero-laxano",
  "mainVegetable/95": "laxanika/leyka-fasolia",
  "mainVegetable/96": "laxanika/apojhramenes-tomates",
  "mainVegetable/97": "laxanika/anameikta-laxanika",
  "mainVegetable/98": "laxanika/kolokytha",
  "productRange": "seires",
  "productRange/4G_BIO": "seires",
  "productRange/4G_SRP": "seires",
  "productRange/CAN_A_POEL": "seires",
  "productRange/CAN_SEC_BI": "seires",
  "productRange/CAN_SEC_CO": "seires",
  "productRange/CAN_SEC_CU": "seires",
  "productRange/CAN_SEC_NA": "seires",
  "productRange/CAN_VAPEUR": "seires",
  "productRange/CAN_VEG_SA": "seires",
  "productRange/CAN_VEG_SR": "seires",
  "productRange/CLASSICVEG": "seires",
  "productRange/COLDVEGE": "seires",
  "productRange/COOKMUSH": "seires",
  "productRange/CRUDITES": "seires",
  "productRange/DE_NOS_PRO": "seires",
  "productRange/DOYMUSHACC": "seires",
  "productRange/DOYMUSHAPE": "seires",
  "productRange/DRYVEGE": "seires",
  "productRange/FROZENVEGE": "seires",
  "productRange/FRZ_ASTUCE": "seires",
  "productRange/FRZ_GRATIN": "seires",
  "productRange/FRZ_KELLO": "seires",
  "productRange/FRZ_LEG_CO": "seires",
  "productRange/FRZ_PUREES": "seires",
  "productRange/FRZ_VEG_BI": "seires",
  "productRange/FRZ_VEG_SR": "seires",
  "productRange/INDFROZVEG": "seires",
  "productRange/JEUNES_POU": "seires",
  "productRange/LAITUES": "seires",
  "productRange/LOOP": "seires",
  "productRange/LUNCH_BOWL": "seires",
  "productRange/MACHE_BASE": "seires",
  "productRange/MEL_LAITUE": "seires",
  "productRange/MUSHNATEMI": "seires",
  "productRange/MUSHNATENT": "seires",
  "productRange/MUSHNATEPA": "seires",
  "productRange/MUSHNATMIN": "seires",
  "productRange/MUSHROOMS": "seires",
  "productRange/SUNVEGE": "seires",
  "productRange/TRAIT_CRUD": "seires",
  "productRange/TRAIT_TABO": "seires",
  "productRange/TUS_RECETA": "seires",
  "productRange/WORLDVEGE": "seires",
  "productRange/PREPARED_VEG": "seires",
  "productRange/BEAN_SAUCE": "seires/fasolia-se-saltsa",
  "productRange/BEANS": "seires/fasolia",
  "productRange/BIO": "seires/biologika",
  "productRange/BOND_KIDS": "seires/bonduelle-gia-paidia",
  "productRange/CAN_BIO": "seires",
  "productRange/CAN_SEC_PR": "seires",
  "productRange/CARTA_DELL": "seires/-",
  "productRange/CAN_PETITS": "seires",
  "productRange/CAN_BOCAL": "seires",
  "productRange/CEREAL_CAN": "seires/sithra-se-konserba",
  "productRange/CEREAL_FRZ": "seires/katepsygmena-sithra",
  "productRange/CEREALI": "seires/sithra",
  "productRange/CEREALLEGR": "seires/-",
  "productRange/COCCOLE": "seires/-",
  "productRange/CORN": "seires/kalampoki",
  "productRange/CREATIF": "seires/-",
  "productRange/FRANCAIS": "seires/100-gallika",
  "productRange/FRZ_FRY_MI": "seires",
  "productRange/FRZ_MELANG": "seires",
  "productRange/FRZ_POELEE": "seires/katepsygmena-etoima-meigmata",
  "productRange/INSALATE_D": "seires/-",
  "productRange/INSALATONA": "seires/-",
  "productRange/LE_REGIONA": "seires/-",
  "productRange/LEGUMIO": "seires/ospria",
  "productRange/MIXES_CORN": "seires/meigmata-me-kalampoki",
  "productRange/MONO_VEGE": "seires/monolaxanika",
  "productRange/MUSHROOMS  ": "seires/manitaria",
  "productRange/NATURA_IN": "seires/-",
  "productRange/OTHER_VEG": "seires/alla-laxanika",
  "productRange/PEAS": "seires/arakas",
  "productRange/READY_FROZ": "seires/etoima-katepsygmena-geymata",
  "productRange/SOUPS": "seires/laxanika-gia-soypa",
  "productRange/SPINACH": "seires/spanaki",
  "productRange/STEAM_CAN": "seires/konserba-se-atmo",
  "productRange/STEAM_FRZ": "seires/katepsygmena-ston-atmo",
  "productRange/STEAM_MIX": "seires/meigmata-katepsygmena-ston-atmo",
  "productRange/STUZZICHIA": "seires/-",
  "productRange/TOUCHE": "seires/mini-konserbes",
  "productRange/TRAIT_SAL": "seires",
  "productRange/TUS_RECETA ": "seires/oi-syntages-sas",
  "productRange/VEG_TO_FRY": "seires/laxanika-gia-thgani",
  "productRange/VEGGIE": "seires/ryzi-laxanikon",
  "productRange/FRZ_JUSTEA": "seires",
  "productRange/SALABIS": "seires",
  "productRange/BON_SENGAG": "seires",
  "productRange/CROUSTIS": "seires",
  "season": "epoxes",
  "season/1": "epoxes/kalokairi",
  "season/2": "epoxes/fthinoporo",
  "season/3": "epoxes/xeimonas",
  "season/4": "epoxes/anoijh",
  "season/5": "epoxes",
  "technologie": "texnologia",
  "technologie/AC01": "texnologia/synterhsh",
  "technologie/AD01": "texnologia/katepsygmena",
  "technologie/AG01": "texnologia/freska",
  "technologie/AT01": "texnologia/trofodosia",
  "recipeDish": "typos-plakas",
  "recipeDish/ACC": "typos-plakas/synodeytiko",
  "recipeDish/APE": "typos-plakas/aperitif",
  "recipeDish/DES": "typos-plakas/epidorpio",
  "recipeDish/ENT": "typos-plakas/orektiko",
  "recipeDish/PLAT": "typos-plakas/piato",
  "recipeDish/SAL": "typos-plakas/salata",
  "recipeDish/SNA": "typos-plakas/snak-mpar",
  "recipeDish/PDE": "typos-plakas/proino",
  "recipeDish/DEJ": "typos-plakas/meshmeriano",
  "recipeDish/TRA": "typos-plakas/paradosiako",
  "recipeDish/GOU": "typos-plakas/faghto-gkoyrme",
  "recipeDish/ETH": "typos-plakas/ethnikothta",
  "recipeDish/FCH": "typos-plakas/gia-paidia",
  "recipeDish/SOU": "typos-plakas/soypa",
  "pred-recipeTimingCook-facet": "psesimo",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "psesimo/0-15-lepta",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "psesimo/15-30-lepta",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "psesimo/30-45-lepta",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "psesimo/45-lepta",
  "pred-recipeTimingPreparation-facet": "paraskeye",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "paraskeye/0-15-lepta",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "paraskeye/15-30-lepta",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "paraskeye/30-45-lepta",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "paraskeye/45-lepta",
  "pred-recipeCost-Facet": "proϋpologismos",
  "pred-recipeCost-Facet/petit": "proϋpologismos/fthno",
  "pred-recipeCost-Facet/moyen": "proϋpologismos/mesaio",
  "pred-recipeCost-Facet/grand": "proϋpologismos/ypshlo",
  "recipeDifficulty": "paraskeye",
  "recipeDifficulty/1": "paraskeye/eykolo",
  "recipeDifficulty/2": "paraskeye/mesaio",
  "recipeDifficulty/3": "paraskeye/polyploko",
  "recipeDishNumber": "episkeptes",
  "recipeDishNumber/1": "episkeptes/1",
  "recipeDishNumber/2": "episkeptes/2",
  "recipeDishNumber/3": "episkeptes/3",
  "recipeDishNumber/4": "episkeptes/4",
  "recipeDishNumber/5": "episkeptes/5",
  "recipeDishNumber/6": "episkeptes/6",
  "recipeDishNumber/7": "episkeptes/7",
  "recipeDishNumber/8": "episkeptes/8",
  "productTheme": "proionta-ana-thema",
  "productTheme/ACC": "proionta-ana-thema/synodeytiko",
  "productTheme/BEA": "proionta-ana-thema/fasolia",
  "productTheme/BIS": "proionta-ana-thema/fasolia-se-saltsa",
  "productTheme/BIO": "proionta-ana-thema/biologika",
  "productTheme/CAN": "proionta-ana-thema/konserba",
  "productTheme/CER": "proionta-ana-thema/sithra",
  "productTheme/CLS": "proionta-ana-thema/klassika",
  "productTheme/DLE": "proionta-ana-thema/laxanika",
  "productTheme/EDR": "proionta-ana-thema/geymata-enrichers",
  "productTheme/ENT": "proionta-ana-thema/orektika",
  "productTheme/FRZ": "proionta-ana-thema/katepsygmena",
  "productTheme/FSD": "proionta-ana-thema/gia-salates",
  "productTheme/FSH": "proionta-ana-thema/amoibes",
  "productTheme/ING": "proionta-ana-thema/systatika-gia-tis-syntages-moy",
  "productTheme/JAR": "proionta-ana-thema/laxanika-se-bazo",
  "productTheme/LBW": "proionta-ana-thema/mpol-meshmerianoy",
  "productTheme/LDF": "proionta-ana-thema/laxanika-ston-foyrno",
  "productTheme/LEG": "proionta-ana-thema/ospria",
  "productTheme/LGO": "proionta-ana-thema/ospria",
  "productTheme/LGR": "proionta-ana-thema/pshta-laxanika",
  "productTheme/LGS": "proionta-ana-thema/laxanika-gia-soypa",
  "productTheme/MAI": "proionta-ana-thema/-",
  "productTheme/MUS": "proionta-ana-thema/manitaria",
  "productTheme/NEW": "proionta-ana-thema/nea-proionta",
  "productTheme/PDH": "proionta-ana-thema/jera-laxanika-koyzina-piata",
  "productTheme/PDL": "proionta-ana-thema/kalathi-me-laxanika",
  "productTheme/PHR": "proionta-ana-thema/zymarika",
  "productTheme/PLP": "proionta-ana-thema/prota-piata",
  "productTheme/RAL": "proionta-ana-thema/ryzi-laxanikon",
  "productTheme/RDM": "proionta-ana-thema/piata-koyzinas",
  "productTheme/SAL": "proionta-ana-thema/ola-gia-tis-salates-moy",
  "productTheme/SDB": "proionta-ana-thema/mpol-salatas",
  "productTheme/SNK": "proionta-ana-thema/snacking",
  "productTheme/SUP": "proionta-ana-thema/soypa",
  "productTheme/TEX": "proionta-ana-thema/tex-mex",
  "productTheme/VGP": "proionta-ana-thema/proteines-laxanikon",
  "recipeTheme": "syntages-ana-thema",
  "recipeTheme/01": "syntages-ana-thema/eortastikes-syntages",
  "recipeTheme/02": "syntages-ana-thema/aperitif",
  "recipeTheme/03": "syntages-ana-thema/salates-kai-snak",
  "recipeTheme/04": "syntages-ana-thema/soypes-kai-gkaspatso",
  "recipeTheme/05": "syntages-ana-thema/kis",
  "recipeTheme/06": "syntages-ana-thema/eidika-gia-paidia",
  "recipeTheme/07": "syntages-ana-thema/epidorpia",
  "recipeTheme/08": "syntages-ana-thema/xortofagoi",
  "recipeTheme/09": "syntages-ana-thema/synodeytika",
  "recipeTheme/10": "syntages-ana-thema/erxontai-apo-makrya",
  "recipeTheme/11": "syntages-ana-thema/sigobrazo",
  "recipeTheme/12": "syntages-ana-thema/salates-et-mparmpekioy",
  "recipeTheme/13": "syntages-ana-thema/snak-et-fingkerfoynt",
  "recipeTheme/14": "syntages-ana-thema/kyrios-piata",
  "recipeTheme/15": "syntages-ana-thema/epidorpia-kai-artoskeyasmata",
  "recipeTheme/16": "syntages-ana-thema/orektika-kai-soypes",
  "recipeTheme/17": "syntages-ana-thema/salates",
  "recipeTheme/18": "syntages-ana-thema/mpol",
  "recipeTheme/19": "syntages-ana-thema/soypes",
  "recipeTheme/20": "syntages-ana-thema/snak",
  "recipeTheme/21": "syntages-ana-thema/sos",
  "recipeTheme/22": "syntages-ana-thema/sketa-piata",
  "recipeTheme/23": "syntages-ana-thema/Άlla-piata",
  "recipeTheme/24": "syntages-ana-thema/foyrnos-piata",
  "recipeTheme/25": "syntages-ana-thema/mejikaniko",
  "recipeTheme/26": "syntages-ana-thema/apo-ton-kosmo",
  "recipeTheme/27": "syntages-ana-thema/mia-mera-xoris-kreas",
  "recipeTheme/28": "syntages-ana-thema/xamhla-se-ydatanthrakes",
  "recipeTheme/33": "syntages-ana-thema/me-bash-fakes",
  "recipeTheme/34": "syntages-ana-thema/me-bash-koynoypidi",
  "recipeTheme/35": "syntages-ana-thema/me-bash-patata",
  "recipeTheme/36": "syntages-ana-thema/me-bash-karoto",
  "recipeTheme/37": "syntages-ana-thema/me-bash-spanaki",
  "recipeTheme/38": "syntages-ana-thema/me-bash-piperies",
  "recipeTheme/39": "syntages-ana-thema/me-bash-manitari",
  "recipeTheme/40": "syntages-ana-thema/me-bash-prasina-fasolia",
  "recipeTheme/41": "syntages-ana-thema/me-bash-kalampoki",
  "recipeTheme/42": "syntages-ana-thema/me-bash-araka",
  "recipeTheme/43": "syntages-ana-thema/me-bash-kokkina-fasolia",
  "recipeTheme/44": "syntages-ana-thema/me-bash-fasolia",
  "recipeTheme/45": "syntages-ana-thema/me-bash-rebythi",
  "recipeTheme/46": "syntages-ana-thema/me-bash-mprokolo",
  "pred-particularite": "diatrofikes-synetheies",
  "pred-particularite/Sans%20conservateur": "diatrofikes-synetheies/xoris-synthrhtika",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "diatrofikes-synetheies",
  "pred-particularite/Sans%20colorant": "diatrofikes-synetheies/xoris-xromatismoys",
  "pred-particularite/Sans%20sucre%20ajout%E9": "diatrofikes-synetheies/xoris-prosthekh-zaxarhs",
  "pred-particularite/Sans%20sel%20ajout%E9": "diatrofikes-synetheies/xoris-prosthekh-alatioy",
  "pred-particularite/Sans%20additif": "diatrofikes-synetheies/xoris-prostheta",
  "pred-particularite/": "diatrofikes-synetheies",
  "pred-particularite/Sans%20lactose": "diatrofikes-synetheies/xoris-laktozh",
  "pred-particularite/Sans%20gluten": "diatrofikes-synetheies/xoris-gloytenh",
  "pred-particularite/V%E9g%E9tarien": "diatrofikes-synetheies/laxanika",
  "pred-particularite/V%E9g%E9talien": "diatrofikes-synetheies/bigkan",
  "pred-particularite/Sans%20sulfite": "diatrofikes-synetheies/xoris-theiodes-alas",
  "pred-particularite/A%20la%20vapeur": "diatrofikes-synetheies/atmos",
  "pred-particularite/Sans%20condiment": "diatrofikes-synetheies/xoris-karykeymata",
  "cultureType": "typos-kalliergeias",
  "cultureType/Bio": "typos-kalliergeias/biologiko",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "typos-kalliergeias/xoris-ypoleimmata-fytofarmakon",
  "cultureType/Sans%20OGM": "typos-kalliergeias/genetika-tropopoihmenoys-organismoys",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "diatrofikes-synetheies/bigkan",
  "pred-particularite/recipeVeggie": "diatrofikes-synetheies/laxanika",
  "pred-particularite/recipeGlutenfree": "diatrofikes-synetheies/xoris-gloytenh",
  "pred-particularite/recipeLactosefree": "diatrofikes-synetheies/xoris-laktozh"
};
